(function () {
  'use strict';

  const angular = window.angular;

  const STRONG_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

  AccountConfirmationController.$inject = [
    'SupportAdmin',
    'LoopBackAuth',
    '$rootScope',
    '$state',
    'AppUtils',
    'UserService',
  ];

  angular.module('app').component('publicAccountConfirmation', {
    template:'<section class="login-container"><div class="login-header"><div class="login-brand"></div><h3 class="no-margin" translate>views.public.confirmAccount.title</h3></div><div class="login-content text-center" ng-if="$ctrl.error"><h4 class="text-danger"><strong translate>errors.UNKNOWN_ERROR</strong></h4><div ng-show="$ctrl.error" ng-switch on="$ctrl.error.code" class="marginB20 paddingB20"><div ng-switch-when="INVALID_TOKEN"><span translate>views.public.confirmAccount.invalidToken</span><div class="text-center marginT20"><a ui-sref="public.login" translate>buttons.signin</a></div></div><div ng-switch-default><span>{{\'errors.\' + $ctrl.error | translate}}</span></div></div></div><div class="login-content" ng-if="$ctrl.confirmed && !$ctrl.success"><p class="text-center marginB20" translate>views.public.confirmAccount.setPasswordMessage</p><form name="$ctrl.setPasswordForm" novalidate class="login-form validate" ng-submit="$ctrl.setPassword()"><div class="form-group" show-errors><div class="input-group"><span class="input-group-addon"><i class="fas fa-key fa-fw"></i></span> <input ng-model="$ctrl.form.password" ng-change="$ctrl.onPasswordChange()" ng-blur="$ctrl.onBlur()" type="password" class="form-control" name="password" required translate-attr="::{placeholder: \'entities._all.password\'}"></div><p ng-messages="$ctrl.setPasswordForm.password.$error" class="help-block" role="alert"><span ng-message="required" translate>form.errors.required</span> <span ng-message="weak" translate>views.public.confirmAccount.weakPassword</span> <span ng-message="password_mismatch" translate>form.errors.passwordMismatch</span></p></div><div class="form-group" show-errors><div class="input-group"><span class="input-group-addon"><i class="fas fa-key fa-fw"></i></span> <input ng-model="$ctrl.form.repeatPassword" ng-change="$ctrl.onPasswordChange()" ng-blur="$ctrl.onBlur()" type="password" class="form-control" name="repeatPassword" required translate-attr="::{placeholder: \'entities.user.password.confirm\'}"></div><p ng-messages="$ctrl.setPasswordForm.repeatPassword.$error" class="help-block" role="alert"><span ng-message="required" translate>form.errors.required</span> <span ng-message="password_mismatch" translate>form.errors.passwordMismatch</span></p></div><ul class="list-unstyled marginB20" style="font-size: 12px"><li ng-class="$ctrl.requirements.length ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="$ctrl.requirements.length ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>views.public.confirmAccount.reqLength</span></li><li ng-class="$ctrl.requirements.upper ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="$ctrl.requirements.upper ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>views.public.confirmAccount.reqUpper</span></li><li ng-class="$ctrl.requirements.lower ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="$ctrl.requirements.lower ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>views.public.confirmAccount.reqLower</span></li><li ng-class="$ctrl.requirements.digit ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="$ctrl.requirements.digit ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>views.public.confirmAccount.reqDigit</span></li><li ng-class="$ctrl.requirements.symbol ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="$ctrl.requirements.symbol ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>views.public.confirmAccount.reqSymbol</span></li></ul><div class="alert alert-warning no-margin text-center marginB20" ng-show="$ctrl.saveError">{{$ctrl.saveError}}</div><button class="btn btn-login btn-lg btn-block" ng-disabled="$ctrl.saving" translate>buttons.save</button></form></div><div class="login-content text-center" ng-if="$ctrl.success"><h4 class="text-success"><i class="far fa-check-circle fa-fw fa-2x"></i> <strong style="display: block" class="marginTB10" translate>views.public.changePass.changedPass</strong></h4><p class="marginB20 paddingB20" translate>views.public.changePass.message</p><div class="text-center marginT20"><a ui-sref="public.login" translate>buttons.signin</a></div></div></section>',
    controller: AccountConfirmationController,
  });

  function AccountConfirmationController(
    SupportAdmin,
    LoopBackAuth,
    $root,
    $state,
    utils,
    UserService
  ) {
    let vm = this;

    this.$onInit = function () {
      vm.uid = $state.params.uid;
      vm.token = $state.params.token;
      vm.form = {};
      vm.requirements = { length: false, upper: false, lower: false, digit: false, symbol: false };

      vm.setPassword = setPassword;
      vm.onPasswordChange = onPasswordChange;
      vm.onBlur = onBlur;

      $root.appReady = false;
      SupportAdmin.confirm({
        uid: vm.uid,
        token: vm.token,
      })
        .$promise.then((accessToken) => {
          LoopBackAuth.setUser(accessToken.id, accessToken.userId);
          LoopBackAuth.save();
          vm.userId = accessToken.userId;
          vm.confirmed = true;
          $root.appReady = true;
        })
        .catch((err) => {
          $root.appReady = true;
          vm.error = utils.getHTTPError(err);
        });
    };

    function onPasswordChange() {
      let password = vm.form.password || '';
      let repeatPassword = vm.form.repeatPassword || '';

      vm.requirements.length = password.length >= 8;
      vm.requirements.upper = /[A-Z]/.test(password);
      vm.requirements.lower = /[a-z]/.test(password);
      vm.requirements.digit = /\d/.test(password);
      vm.requirements.symbol = /[^A-Za-z0-9]/.test(password);

      if (!password || !repeatPassword || password === repeatPassword) {
        vm.setPasswordForm.password.$setValidity('password_mismatch', true);
        vm.setPasswordForm.repeatPassword.$setValidity('password_mismatch', true);
      }
      vm.setPasswordForm.password.$setValidity('weak', true);
    }

    function onBlur() {
      let password = vm.form.password || '';
      let repeatPassword = vm.form.repeatPassword || '';
      let matches = !password || !repeatPassword || password === repeatPassword;
      vm.setPasswordForm.password.$setValidity('password_mismatch', matches);
      vm.setPasswordForm.repeatPassword.$setValidity('password_mismatch', matches);
    }

    function setPassword() {
      let password = vm.form.password;
      let repeatPassword = vm.form.repeatPassword;

      if (password !== repeatPassword) {
        vm.setPasswordForm.password.$setValidity('password_mismatch', false);
        vm.setPasswordForm.repeatPassword.$setValidity('password_mismatch', false);
      }

      vm.setPasswordForm.password.$setValidity('weak', STRONG_PASSWORD_REGEX.test(password || ''));

      if (!vm.setPasswordForm.$valid) {
        return;
      }

      vm.saving = true;
      vm.saveError = null;
      UserService
        .setPassword(vm.userId, password)
        .then(() => {
          vm.saving = false;
          LoopBackAuth.clearUser();
          LoopBackAuth.clearStorage();
          vm.success = true;
        })
        .catch((err) => {
          vm.saving = false;
          vm.saveError = utils.getHTTPError(err);
        });
    }
  }
})();
